'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { Toaster } from 'sonner';
import { PwaManager } from '@/components/pwa/pwa-manager';
import { TooltipProvider } from '@/components/ui/overlays';
import { ApiError } from '@/lib/api';

export function Providers({ children }: { children: React.ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
          },
        },
      }),
  );
  return (
    <QueryClientProvider client={client}>
      <TooltipProvider>
        {children}
        <PwaManager />
        <Toaster
          theme="dark"
          // Bottom-right: over the closed-trades list of the order panel (which shows
          // the same results), clear of the header, the round and the entry buttons.
          // On phones, above the bottom navigation bar.
          position="bottom-right"
          offset={{ bottom: 16, right: 16 }}
          mobileOffset={{ bottom: 76, left: 12, right: 12 }}
          visibleToasts={3}
          gap={8}
          // Theme the default toasts via sonner's variables; custom toasts (WIN/LOSS) draw their own card.
          style={{ '--normal-bg': 'var(--color-panel)', '--normal-border': 'var(--color-border)', '--normal-text': 'var(--color-fg)', '--border-radius': '14px' } as React.CSSProperties}
          toastOptions={{ classNames: { description: '!text-fg-2' } }}
        />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
